export const DEFAULT_EMPTY_VALUE = 'No disponible';
export const DEFAULT_WRONG_DATE = 'Fecha inválida';
export const EXCLUDED_404_ENDPOINTS = ['accounts/passwords'];
